import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import { NO_RESULTS_REC_IDS } from "../config"

export default function NoResults() {
    const { response: { query } } = useAppState();

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements(NO_RESULTS_REC_IDS)
            .load({ skipPageViews: true })
        })
    }, []);

    return (
        <div class="ns-no-results">
            <div class="ns-no-results__text-container ns-flex ns-flex-col">
                <h2 className="ns-no-results__heading">
                    Sorry! We found no results for "{query}".
                </h2>
                <p className="ns-no-results__desc">
                    Double check your spelling or try again with a less specific term.
                </p>
            </div>

            <div class="ns-no-results__recs">
                {NO_RESULTS_REC_IDS.map(recId => (
                    <div class="nosto_element" id={recId} />
                ))}
            </div>
        </div>
    )
}
